/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsFAQ = {
  init() {
    window.PXUTheme.collapsibleRowUtil.init();
  },
  unload() {
    window.PXUTheme.collapsibleRowUtil.unload();
  },
};

/******/ })()
;